<txtb-drawer
  #drawerComponent
  [actionId]="action.id"
  [groupInfo]="groupInfo"
  [textbookPageId]="action.textbookPageId"
  [textbookId]="action.textbookId"
  [actionContentCollapsed]="actionContentCollapsed"
  [zoomFeatureAvailable]="true"
  (contentCollapse)="contentCollapse($event)"
  (actionContentWrapperRendered)="onActionContentWrapperRendered($event)"
  (actionDrawerApiInitialized)="onActionDrawerApiInitialized($event)"
>
  <ng-container main>
    <article class="exercise-image" #wrapper>
      <txtb-image-wrapper
        style="height: 100%; width: 100%"
        #img
        [verticalScroll]="!!(verticalScroll$ | async)"
        [horizontalScroll]="!!(horizontalScroll$ | async)"
        [isScrolled]="!!((verticalScroll$ | async) || (horizontalScroll$ | async))"
        [src]="this.questionImage$ | async"
        (imageLoad)="onLoaded()"
        [scrollDisabled]="(drawerComponent?.drawingByPointerMove$ | async) === true || (drawerComponent?.percentageZoom$ | async) !== MAX_PERCENT"
        [imagesScalingEnabled]="!!action.meta?.imagesScalingEnabled"
        [percentageScale]="(question$ | async)?.percentageScale || null"
      ></txtb-image-wrapper>
    </article>
  </ng-container>

  <section footer class="bottom-ui">
    <button
      id="exercise-tip-btn"
      class="tip-button"
      [class.is-hidden]="!(tipImageUrl$ | async) === true"
      (click)="toggleModal(0)"
    >
      <div class="button-elements">
        <div class="icon">
          <txtb-icons type="showTip"></txtb-icons>
        </div>
        <span class="icon-text"> {{ (tipTitle$ | async) }}</span>
      </div>
    </button>

    <txtb-paginator
      [activeElement]="activeElement"
      [subSectionLength]="subSectionLength"
      [subPointsShown]="subPointsShown"
      (changeElement)="changeElement($event)"
      class="paginator"
    ></txtb-paginator>

    <button
      id="exercise-switch-display-mode-btn"
      class="switch-button"
      [class.is-hidden]="!subSectionLength || !action.meta.question"
      (click)="switchScreen()"
    >
      <div class="button-elements">
        <div class="icon">
          <div *ngIf="this.subPointsShown; then thenBlock; else elseBlock"></div>
          <ng-template #thenBlock>
            <txtb-icons type="showAllExample"></txtb-icons>
          </ng-template>
          <ng-template #elseBlock>
            <txtb-icons type="showOnlyOneExample"></txtb-icons>
          </ng-template>
        </div>
        <span class="icon-text"> {{ this.buttonState }}</span>
      </div>
    </button>

    <button
      id="exercise-answer-btn"
      class="answer-button"
      [class.is-hidden]="!(answerImageUrl$ | async) === true"
      (click)="toggleModal(1)"
    >
      <div class="button-elements">
        <div class="icon">
          <txtb-icons type="showAnswer"></txtb-icons>
        </div>
        <span class="icon-text">{{ answerTitle }}</span>
      </div>
    </button>
  </section>
</txtb-drawer>

<txtb-modal
  type="plain"
  [size]="modalCompactSize"
  *ngIf="this.modalOpened && modalState"
  [bgPositionConfig]="!!(answerModalPositionConfig$ | async) === true ? (modalBgPositionConfig$ | async) : null"
  [positionConfig]="(answerModalPositionConfig$ | async)"
  (closeModal)="closeModal()"
>
  <txtb-image-wrapper
    class="answer-image" main
    *ngIf="(answer$ | async) as answer"
    [fixRender]="true"
    [src]="answerImage$ | async"
    [imgSrc]="answerImage$ | async"
    [imagesScalingEnabled]="!!answer.image?.percentageScale && !!action.meta?.imagesScalingEnabled"
    [percentageScale]="answer.image?.percentageScale || null"
    [verticalScroll]="!!answer.image?.verticalScroll"
    [horizontalScroll]="!!answer.image?.horizontalScroll"
  ></txtb-image-wrapper>
</txtb-modal>
<txtb-modal
  type="plain"
  [size]="modalCompactSize"
  *ngIf="this.modalOpened && !modalState"
  [bgPositionConfig]="!!(tipModalPositionConfig$ | async) === true ? (modalBgPositionConfig$ | async) : null"
  [positionConfig]="(tipModalPositionConfig$ | async)"
  (closeModal)="closeModal()"
>
  <txtb-image-wrapper
    class="answer-image" main
    *ngIf="(tip$ | async) as tip" [src]="tipImage$ | async"
    [imagesScalingEnabled]="!!tip.image.percentageScale && !!action.meta?.imagesScalingEnabled"
    [percentageScale]="tip.image.percentageScale"
    [verticalScroll]="tip.image.verticalScroll"
    [horizontalScroll]="tip.image.horizontalScroll"></txtb-image-wrapper>
</txtb-modal>
